(function () {
  var openedOverlay = null;

  function openModal(overlay, opener) {
    overlay.__opener = opener;
    overlay.hidden = false;
    document.body.classList.add('overflow-hidden');
    openedOverlay = overlay;
    var dialog = overlay.querySelector('.size-guide__dialog');
    if (dialog) dialog.focus();
  }

  function closeModal(overlay) {
    overlay.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (overlay.__opener && typeof overlay.__opener.focus === 'function') {
      overlay.__opener.focus();
    }
    openedOverlay = null;
  }

  function init() {
    document.querySelectorAll('.size-guide__overlay').forEach(function (overlay) {
      // Move the overlay to <body> so position:fixed is relative to the
      // viewport. Inside the product column it can sit under a transformed
      // ancestor, which traps fixed positioning and stops it freezing the page.
      if (overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }

      if (overlay.dataset.sizeGuideWired) return;
      overlay.dataset.sizeGuideWired = 'true';

      var closeBtn = overlay.querySelector('[data-size-guide-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeModal(overlay);
        });
      }

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closeModal(overlay);
      });
    });

    document.querySelectorAll('[data-size-guide-open]').forEach(function (opener) {
      if (opener.dataset.sizeGuideWired) return;
      opener.dataset.sizeGuideWired = 'true';

      opener.addEventListener('click', function () {
        var overlay = document.getElementById(opener.getAttribute('data-size-guide-open'));
        if (overlay) openModal(overlay, opener);
      });
    });

    if (!document.__sizeGuideEscape) {
      document.__sizeGuideEscape = true;
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && openedOverlay) closeModal(openedOverlay);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
